export default "__VITE_ASSET__B7BPbjH0__"